import React, { useEffect } from 'react'

type Props = {
    lang: string
}

export const DocumentLanguage = (props: Props) => {
    useEffect(() => {
        if (!props.lang) {
            return
        }
        document.documentElement.lang = props.lang
    }, [props.lang])

    return <></>
}
